import React, { useEffect, useState } from "react";
import Navbar from "../../../components/Navbar";
import Sidebar from "../../../components/Sidebar";
import { IS_STAGING } from "../../../constant/api";
import { API_URL, PROD_LINK } from "../../../constant";
import { STAGING_LINK } from "../../../constant";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { TailSpin } from "react-loader-spinner";
import EmptyData from "../../../components/EmptyData";
import { useAuth } from "../../../context/auth-context";
import toast from "react-hot-toast";
import axiosInstance from "../../../utils/axiosConfig";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import { IoCheckboxOutline, IoTrashOutline } from "react-icons/io5";
import { MdAdd } from "react-icons/md";
import { FaRegEye } from "react-icons/fa";
import { TbFileDownload } from "react-icons/tb";
import RuleDetailsModal from "./RuleDetailsModal";
import CreateRuleModal from "./CreateRuleModal";
import { IoMdCloseCircleOutline } from "react-icons/io";

const Rules = () => {
  const [rulesLoader, setRulesLoader] = useState(false);
  const [rules, setRules] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const [refetch, setRefetch] = useState(0);
  const [openEdit, setOpenEdit] = useState<{ [key: number]: boolean }>({});
  const [editLoader, setEditLoader] = useState<boolean[]>([]);
  const [deleteLoader, setDeleteLoader] = useState<boolean[]>([]);
  const { isAuthenticated } = useAuth();
  const [showRuleModal, setShowRuleModal] = useState(false);
  const [selectedRule, setSelectedRule] = useState<any>(null);
  const [showCreateModal, setShowCreateModal] = useState(false);

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "pm" : "am";

    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes.toString().padStart(2, "0");

    return `${month} ${day}${getDaySuffix(
      day
    )}, ${year} | ${formattedHours}:${formattedMinutes}${ampm}`;
  };

  const getDaySuffix = (day: number) => {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const toggleModal = (objectId: number) => {
    setOpenEdit((prev) => ({
      ...prev,
      [objectId]: !prev[objectId], // Toggle the state for the specific object
    }));
  };
  const closeModal = (objectId: number) => {
    setOpenEdit((prev) => ({
      ...prev,
      [objectId]: !prev[objectId], // Close the modal for the specific object
    }));
  };

  useEffect(() => {
    if (!isAuthenticated) return; // Don't fetch before the session bootstrap has confirmed one

    setRulesLoader(true);

    const fetchData = async () => {
      try {
        const { data } = await axiosInstance.get(
          `${API_URL}api/rules?page=${page}&limit=${PAGE_SIZE}`
        );

        // console.log(data.data);

        const sortedRules = data.data.rules.sort(
          (a: any, b: any) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );

        setTotalPages(data.data.totalPages);
        setCurrentPage(data.data.page);
        setRules(sortedRules);
      } catch (error: any) {
        console.log(error.response?.data?.message || "An error occurred");
        toast.error(error.response?.data?.message || "An error occurred");
      } finally {
        setRulesLoader(false);
      }
    };

    fetchData();
  }, [page, isAuthenticated, refetch]);

  // For now, use dummy data
  const PAGE_SIZE = 15;
  return (
    <div className="w-full h-screen flex flex-col overflow-hidden">
      <div className="w-full h-[31px] shrink-0 bg-[#1B1B1B] flex justify-center items-center">
        {IS_STAGING ? (
          <h4 className="font-medium text-[#AEBCC6] text-[12px]">
            You are in Staging:{" "}
            <span>
              <a href={PROD_LINK} className="text-[#03C668]">
                Switch to Prod
              </a>
            </span>
          </h4>
        ) : (
          <h4 className="font-medium text-[#AEBCC6] text-[12px]">
            You are in PROD:{" "}
            <span>
              <a href={STAGING_LINK} className="text-[#DF4E4E]">
                Switch to Staging
              </a>
            </span>
          </h4>
        )}
      </div>
      <div className="flex flex-1 min-h-0 w-full flex-col lgss:flex-row overflow-hidden">
        <Sidebar />
        <div className="w-full lgss:w-10/12 flex-1 min-h-0 min-w-0 overflow-y-auto bg-[#13181B]">
          <Navbar />
          <div className="w-full px-5 h-full pt-8 mds:px-12 font-manrope lgss:px-10  bg-[#13181B]">
            <div className="w-full font-manrope mt-8">
              <h3 className="font-sora text-[12px] font-semibold text-white">
                RULE MANAGER
              </h3>
              <div className="bg-[#0D0D0D] h-[calc(100vh-400px)] mt-4 pb-4 w-full font-manrope flex flex-col justify-between">
                <div className="overflow-auto ">
                  <table className="w-full">
                    <thead className="sticky top-0 bg-[#1C2227] z-10">
                      <tr className="h-[56px] flex justify-start gap-4 items-center px-4">
                        <th className="text-[#617889] text-[15px] w-1/6 flex items-center gap-1 cursor-pointer">
                          Rule name
                        </th>
                        <th className="text-[#617889] text-[15px] w-1/6 text-left">
                          Type
                        </th>
                        <th className="text-[#617889] text-[15px] w-[26.667%] text-left">
                          Trigger Logic
                        </th>

                        <th className="text-[#617889] text-[15px] w-[9.6667%] text-left">
                          Status
                        </th>
                        <th className="text-[#617889] text-[15px] w-[23.6667%] text-left">
                          Date Logged
                        </th>

                        <th className="text-[#617889] text-[15px] w-[6.6667%] text-center">
                          &nbsp;
                        </th>
                      </tr>
                    </thead>
                    {rulesLoader ? (
                      <tbody>
                        <tr>
                          <td colSpan={8}>
                            <div className="flex justify-center items-center h-40">
                              <TailSpin
                                width={40}
                                height={40}
                                color="#BEE1FB"
                              />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    ) : (
                      <tbody>
                        {rules.length === 0 ? (
                          <tr>
                            <td colSpan={8}>
                              <EmptyData />
                            </td>
                          </tr>
                        ) : (
                          rules.map((txn, idx) => {
                            const deleteRule = async () => {
                              setDeleteLoader((prev) => {
                                const updated = [...prev];
                                updated[idx] = true;
                                return updated;
                              });

                              try {
                                const { data: data2 } =
                                  await axiosInstance.delete(
                                    `${API_URL}api/rules/${txn?._id}`
                                  );
                                setRefetch((prev: number) => prev + 1);
                                toast.success(`Rule deleted successfully`);
                              } catch (error: any) {
                                console.log(
                                  error.response?.data?.message ||
                                    "An error occurred"
                                );
                                toast.error(
                                  error.response?.data?.message ||
                                    "An error occurred"
                                );
                              } finally {
                                setDeleteLoader((prev) => {
                                  const updated = [...prev];
                                  updated[idx] = false;
                                  return updated;
                                });
                                closeModal(idx);
                              }
                            };

                            const editRule = async () => {
                              setEditLoader((prev) => {
                                const updated = [...prev];
                                updated[idx] = true;
                                return updated;
                              });

                              try {
                                const { data: data2 } = await axiosInstance.put(
                                  `${API_URL}api/rules/${txn?._id}`,
                                  {
                                    name: txn?.name,
                                    category: txn?.category,
                                    condition: {
                                      operator: txn?.condition?.operator,
                                      value: txn?.condition?.value, // 500 NGN
                                      timeWindow: txn?.condition?.timeWindow,
                                    },
                                    action: txn?.action, // hold,flag,notify
                                    isEnabled: !txn?.isEnabled,
                                    notes: txn?.notes,
                                  }
                                );
                                setRefetch((prev: number) => prev + 1);
                                toast.success(`Rule updated successfully`);
                              } catch (error: any) {
                                console.log(
                                  error.response?.data?.message ||
                                    "An error occurred"
                                );
                                toast.error(
                                  error.response?.data?.message ||
                                    "An error occurred"
                                );
                              } finally {
                                setEditLoader((prev) => {
                                  const updated = [...prev];
                                  updated[idx] = false;
                                  return updated;
                                });
                                closeModal(idx);
                              }
                            };
                            return (
                              <tr
                                key={idx}
                                className="h-[56px] flex justify-start items-center px-4 border-b gap-4 border-[#23282D] cursor-pointer hover:bg-[#181B1F]"
                              >
                                <td className="text-white w-1/6  text-[14px] text-left">
                                  {txn.name}
                                </td>
                                <td className="text-white w-1/6 flex flex-col items-start gap-1 whitespace-nowrap overflow-hidden text-ellipsis text-[14px] text-left">
                                  <span>{txn.category} </span>
                                </td>
                                <td className="text-white w-[26.667%] text-[14px] whitespace-nowrap overflow-hidden text-ellipsis text-left">
                                  {txn.notes}
                                </td>
                                <td className="w-[9.6667%]">
                                  <span
                                    className={`  px-2 text-[11px] py-1 rounded-full text-xs font-bold 
                    ${
                      txn?.isEnabled
                        ? "text-[#359943] bg-[#359943]/10"
                        : "bg-[#C60303]/10 text-[#C60303]"
                    }
                 
                    `}
                                  >
                                    {txn?.isEnabled ? "Active" : "Disabled"}
                                  </span>
                                </td>
                                <td className="text-white w-[23.6667%] text-[14px] text-left">
                                  {formatDate(txn.createdAt)}
                                </td>

                                <td className="w-[6.6667%] flex justify-center">
                                  <BiDotsHorizontalRounded
                                    onClick={() => {
                                      toggleModal(idx);
                                    }}
                                    className="text-[#869AA9] text-2xl cursor-pointer"
                                  />
                                  {openEdit[idx] && (
                                    <div
                                      onClick={() => {
                                        if (openEdit[idx]) {
                                          closeModal(idx);
                                        }
                                      }}
                                      className=" fixed inset-0 flex font-manrope justify-end pr-20 z-50  items-center bg-black bg-opacity-20  "
                                    >
                                      <div className="w-[190px]   bg-[#1C2227]  ">
                                        <div
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            closeModal(idx);
                                            setSelectedRule(txn);
                                            setShowRuleModal(true);
                                          }}
                                          className=" w-full border-b border-[#13181B] flex justify-between px-4  py-3 items-center"
                                        >
                                          <h4 className="text-white text-[15px]  ">
                                            View Details
                                          </h4>
                                          <FaRegEye className="text-white" />
                                        </div>
                                        <div
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            editRule();
                                          }}
                                          className=" w-full border-b border-[#13181B] flex justify-between px-4  py-3 items-center"
                                        >
                                          <h4 className="text-white text-[15px]  ">
                                            {txn?.isEnabled
                                              ? "Disable"
                                              : "Enable"}
                                          </h4>
                                          <span>
                                            {editLoader[idx] ? (
                                              <TailSpin
                                                color="#ffffff"
                                                width={20}
                                                height={20}
                                              />
                                            ) : (
                                              <div>
                                                {txn?.isEnabled ? (
                                                  <IoMdCloseCircleOutline
                                                    className={` text-xl text-[#C60303]`}
                                                  />
                                                ) : (
                                                  <IoCheckboxOutline
                                                    className={` text-xl text-[#359943]`}
                                                  />
                                                )}
                                              </div>
                                            )}
                                          </span>
                                        </div>

                                        <div
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            deleteRule();
                                          }}
                                          className=" w-full  flex justify-between px-4  border-b border-[#13181B] py-3 items-center"
                                        >
                                          <h4 className="text-[#C60303] text-[15px]  ">
                                            Delete
                                          </h4>
                                          <span>
                                            {deleteLoader[idx] ? (
                                              <TailSpin
                                                color="#ffffff"
                                                width={20}
                                                height={20}
                                              />
                                            ) : (
                                              <IoTrashOutline className="text-[#C60303] text-[16px]" />
                                            )}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </td>
                              </tr>
                            );
                          })
                        )}
                        <tr
                          onClick={() => setShowCreateModal(true)}
                          className="h-[56px] flex justify-start items-center px-4 border-b gap-2 border-[#23282D] cursor-pointer hover:bg-[#181B1F]"
                        >
                          <MdAdd className="text-secondary_button" />
                          <span className="text-secondary_button font-bold">
                            Add New
                          </span>
                        </tr>
                      </tbody>
                    )}
                  </table>

                  {/* Pagination */}
                </div>
                <div className="flex justify-end items-center px-2 py-2">
                  <div className="flex gap-2 items-center">
                    <span className="text-[#869AA9] text-xs">
                      {currentPage} of {totalPages} page{totalPages > 1 && "s"}
                    </span>
                    <button
                      className={`w-[27px] h-[27px] rounded-lg flex justify-center items-center text-[#1C2227] border border-[#1C2227]`}
                      onClick={() => {
                        if (page === 1) {
                          setPage(1);
                        } else {
                          setPage(page - 1);
                        }
                      }}
                      disabled={page === 1}
                    >
                      <FiChevronLeft className="text-[#BDBDBE] text-xl" />
                    </button>
                    <button
                      className={`w-[27px] h-[27px] rounded-lg font-bold text-[13px] flex bg-[#BEE1FB] justify-center items-center text-[#0D0D0D] ${
                        page === 1
                          ? "opacity-100 ext-[#0D0D0D] bg-[#BEE1FB]"
                          : " bg-transparent text-white"
                      }`}
                      onClick={() => setPage(1)}
                      disabled={page === 1}
                    >
                      {page}
                    </button>

                    <button
                      className={`w-[27px] h-[27px] rounded-lg flex justify-center items-center text-[#1C2227] border border-[#1C2227]`}
                      onClick={() => {
                        if (page < totalPages) {
                          setPage(page + 1);
                        }
                      }}
                      disabled={page === totalPages}
                    >
                      <FiChevronRight className="text-[#BDBDBE] text-xl" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <RuleDetailsModal
        isOpen={showRuleModal}
        onClose={() => setShowRuleModal(false)}
        rule={selectedRule}
      />
      <CreateRuleModal
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
      />
    </div>
  );
};

export default Rules;
